import { VStack } from '@nettbureau/vibrant-ui';
import { ReactNode } from 'react';

interface ContainerContentProps {
  children?: ReactNode;
}
export function ContainerContent({ children }: ContainerContentProps) {
  return (
    <VStack justify="center" align="center">
      {children}
    </VStack>
  );
}
